import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { useSelector } from "react-redux";
import { store } from "../../store/store";

const baseUrl =process.env.REACT_APP_base_URL;

const acceptMeeting = createApi({
    reducerPath: 'acceptMeeting',
    baseQuery: fetchBaseQuery({
        baseUrl: baseUrl,
        prepareHeaders: (headers) => {
            // const token = useSelector((state)=> state.user.token)
            const token = store.getState().user.token;
            if (token) {
              headers.set('Authorization', `Bearer ${token}`);
            }
            return headers;
        },
    }),
    endpoints: (builder) => ({
        acceptMeetingInvitation: builder.mutation({
            query: ({  userId , meetingId }) => ({
                url: `meetings/accept`,
                method: 'POST',
                body: {
                    user_id: userId,
                    meeting_id: meetingId,
                }
            }),
            transformResponse: (response) => {
            return response
            },
        }),
    }),
});

export const { useAcceptMeetingInvitationMutation } = acceptMeeting;
export default acceptMeeting;
